export function useLogoutRedirect() {
  const ls = useLsStorage()
  const { user } = useAuth()
  // Lấy redirect path là path hiện tại, bao gồm cả query params nếu có
  const redirectPath = encodeURIComponent(window.location.pathname + window.location.search)
  const userNameQuery = `?redirect=${redirectPath}&u=${user?.username || ''}&clientId=${import.meta.env.VITE_CLIENT_ID}`
  setTimeout(() => {
    ls.clear()
    window.location.replace(`${import.meta.env.VITE_REDIRECT_URL_LOGOUT}${userNameQuery}`)
  })
}
